import { DialogContentText } from "@mui/material";
import TeambookTextForm from "../../../default_components/TeambookTextForm";
import PasswordRules from "../../../register/PasswordRules";
import { useTranslation } from "react-i18next";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";
import { useRef } from "react";

export const PasswordChangingModal = ({
  passwordChangingMenuOpen,
  closePasswordChangingModal,
  setNewPassword,
  newPassword,
  newPasswordShown,
  setNewPasswordShown,
  setPasswordRulesVisible,
  setNewPasswordConf,
  newPasswordConf,
  confNewPasswordShown,
  setConfNewPasswordShown,
  passwordRulesVisible,
  errorMessage,
  errorField,
  closeErrorMessage,
  updateUserPassword,
}) => {
  const { t } = useTranslation();
  const passwordRulesRef = useRef(null);

  return (
    <TeambookDialog
      open={passwordChangingMenuOpen}
      title={t("profile.password.password_changing")}
      onClose={closePasswordChangingModal}
      withCloseButton
      size={"large"}
      content={
        <>
          <DialogContentText>
            <p>{t("profile.password.text_1")}</p>
          </DialogContentText>
          <div className="password-changing__inputs">
            <TeambookTextForm
              placeholder={t("profile.password.new_password_placeholder")}
              className={"password-changing-first__input"}
              fieldName={t("profile.password.new_password")}
              onChange={setNewPassword}
              fieldValue={newPassword}
              type={"password"}
              width={"270px"}
              isPassword={true}
              showPass={newPasswordShown}
              setShowPass={() => setNewPasswordShown(!newPasswordShown)}
              onFocus={() => setPasswordRulesVisible(true)}
              onBlur={() => {
                passwordRulesRef.current.blurPassword();
                setPasswordRulesVisible(true);
              }}
            />
            <TeambookTextForm
              placeholder={t("profile.password.new_password_placeholder")}
              className={"password-changing-second__input"}
              whiteSpace={"noWrap"}
              fieldName={t("profile.password.confirm_new_password")}
              onChange={setNewPasswordConf}
              fieldValue={newPasswordConf}
              isPassword={true}
              showPass={confNewPasswordShown}
              setShowPass={() => setConfNewPasswordShown(!confNewPasswordShown)}
              type={"password"}
              width={"270px"}
              errorField={errorField}
              errorMessage={errorMessage}
              field={"confirmation_password"}
              closeErrorMessage={closeErrorMessage}
              onBlur={() => setPasswordRulesVisible(true)}
            />
          </div>
          <div style={{ display: "flex" }}>
            <PasswordRules password={newPassword} visible={passwordRulesVisible} ref={passwordRulesRef} />
          </div>
        </>
      }
      actionButtons={[{ text: t("submit"), onClick: updateUserPassword }]}
    />
  );
};

PasswordChangingModal.propTypes = {
  passwordChangingMenuOpen: PropTypes.bool.isRequired,
  closePasswordChangingModal: PropTypes.func.isRequired,
  setNewPassword: PropTypes.func.isRequired,
  newPassword: PropTypes.string.isRequired,
  newPasswordShown: PropTypes.bool.isRequired,
  setNewPasswordShown: PropTypes.func.isRequired,
  setPasswordRulesVisible: PropTypes.func.isRequired,
  setNewPasswordConf: PropTypes.func.isRequired,
  newPasswordConf: PropTypes.string.isRequired,
  confNewPasswordShown: PropTypes.bool.isRequired,
  setConfNewPasswordShown: PropTypes.func.isRequired,
  passwordRulesVisible: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  errorField: PropTypes.string,
  closeErrorMessage: PropTypes.func.isRequired,
  updateUserPassword: PropTypes.func.isRequired,
};
